var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import Button from "@mui/material/Button";
import FileUploadIcon from "@mui/icons-material/FileUpload";
export var SingleFileUploadButton = function (_a) {
    var onFileUpload = _a.onFileUpload, id = _a.id;
    var _b = useState(""), errorMsg = _b[0], SetErrorMsg = _b[1];
    var supportedFileTypes = ".txt, .doc, .docx, .pdf, .xls, .xlsx, .jpg, .jpeg, .txt, .json, .png, .csv, .zip, .gz";
    var maxFileSizeMB = 15;
    var inputRef = React.useRef(null);
    var clearInputValue = function () {
        var inputEl = inputRef.current;
        if (inputEl) {
            inputEl.value = '';
        }
    };
    var validFileSize = function (file) {
        return file.size / (1024 * 1024) < maxFileSizeMB;
    };
    var validMinFileSize = function (file) {
        return file.size > 0;
    };
    var validFileType = function (file) {
        return supportedFileTypes.includes(file.name.split('.').pop() || '');
    };
    var validateInputFiles = function (file) {
        if (!validMinFileSize(file)) {
            SetErrorMsg("File can't be empty");
            return false;
        }
        if (!validFileSize(file)) {
            SetErrorMsg("Max file size - 15 MB");
            return false;
        }
        if (!validFileType(file)) {
            SetErrorMsg("Not supported file");
            return false;
        }
        SetErrorMsg("");
        return true;
    };
    var upload = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var fileList, currentFile, formData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fileList = event.target.files;
                    if (!fileList)
                        return [2 /*return*/];
                    currentFile = fileList[0];
                    clearInputValue();
                    if (!validateInputFiles(currentFile)) return [3 /*break*/, 2];
                    formData = new FormData;
                    formData.append("File", currentFile);
                    formData.append("FileSize", currentFile.size.toString());
                    formData.append("FileName", currentFile.name);
                    /* specific */
                    return [4 /*yield*/, onFileUpload(formData)];
                case 1:
                    /* specific */
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { children: [_jsx("input", { style: { display: 'none' }, id: id, type: "file", accept: supportedFileTypes, name: 'file', onChange: upload, ref: inputRef }), _jsx("label", __assign({ htmlFor: id }, { children: _jsx(Button, __assign({ component: "span", sx: { color: 'black', textDecoration: "underline", padding: "0" }, variant: "text", size: "medium", startIcon: _jsx(FileUploadIcon, { fontSize: "small", sx: { color: 'black' } }) }, { children: "Upload" })) })), _jsx("label", __assign({ style: { color: 'red' }, htmlFor: id }, { children: errorMsg }))] }));
};
